export function initPaymentCompletePage() {

    const cesKey = document.querySelector("[data-redemption-ces-key]")?.dataset?.redemptionCesKey;
    window.customerEffortScore.trigger(cesKey);

}